import { useEffect } from "react";

export function useWindowClick(onClick: () => void) {
    useEffect(() => {
        window.addEventListener("click", onClick);

        return () => window.removeEventListener("click", onClick);
    }, [onClick]);
}
